import React, { useState, useEffect } from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

function ResultsSection({ isLoading, imageUrls, activePrompt, activeImage, setActiveImage }) {
  // If isLoading is true, render the loading indicators
  if (isLoading) {
    return (
      <div id="results-section" className="results-section">
        {/* Main Image Loading */}
        <div style={{ height: '500px', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
          <div className="ai-loader">&nbsp;</div>
          Bitte bis zu 30 Sekunden warten...
        </div>

        {/* Preview Images Loading */}
        <Row className="justify-content-center" style={{ marginTop: '20px', borderTop: '1px solid lightgray' }}>
          {imageUrls.map((_, index) => (
            <Col key={index} xs={6} lg={3} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '10px 0' }}>
              <div className="ai-loader">&nbsp;</div>
            </Col>
          ))}
        </Row>
      </div>
    );
  }

  // If isLoading is false, render the images
  return (
    <div id="results-section" className="results-section">
      {/* Main Image */}
      <img src={activeImage} alt="Active Image" height="500"
          style={{ 
            maxWidth: '100%', 
            maxHeight: '500px', 
            height: 'auto',
            width: 'auto',
            marginBottom: '20px', 
          }}  />

      {/* Preview Images */}
      <Row className="justify-content-center">
        {imageUrls.map((url, index) => (
          <Col key={url} xs={6} lg={3} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '5px 0' }}>
            <img
              src={url}
              alt={`Result ${index + 1}`}
              width="150"
              style={{ 
                maxWidth: '100%', 
                maxHeight: '500px', 
                height: 'auto',
                width: 'auto',
                marginBottom: '20px',
                cursor: 'pointer'
              }}
              onClick={() => setActiveImage(url)}
            />
          </Col>
        ))}
      </Row>
      <Row>
            {/* activePrompt goes here */}
            <Col>
              <p>{activePrompt}</p>
            </Col>
      </Row>
    </div>
  );
}

export default ResultsSection;
